(function () {
  function ready() {
    document.querySelectorAll('.pb-feedback[data-pb-feedback]').forEach(function (root) {
      var form = root.querySelector('form');
      var contact = root.querySelector('[data-feedback-step="contact"]');
      var details = root.querySelector('[data-feedback-step="details"]');
      var next = root.querySelector('[data-feedback-next]');
      var back = root.querySelector('[data-feedback-back]');
      var stages = root.querySelectorAll('[data-feedback-stage]');
      if (!form || !contact || !details || !next || !back) return;
      var email = form.querySelector('input[name="contact[email]"]');
      var phone = form.querySelector('input[name="contact[phone]"]');
      var radios = form.querySelectorAll('input[name="contact[Product]"]');
      var flavour = form.querySelector('input[name="contact[Flavour]"]');
      var flavourLabel = root.querySelector('[data-feedback-flavour]');
      var stars = root.querySelectorAll('.pb-feedback__star');
      var ratingText = root.querySelector('[data-feedback-rating-text]');
      function moveTo(second) {
        contact.classList.toggle('is-complete', second);
        details.classList.toggle('is-active', second);
        stages.forEach(function (stage, index) {
          stage.classList.toggle('is-current', second ? index === 1 : index === 0);
          if ((second ? index === 1 : index === 0)) stage.setAttribute('aria-current', 'step');
          else stage.removeAttribute('aria-current');
        });
        var target = second ? details.querySelector('h2') : email;
        if (target) {
          target.setAttribute('tabindex', '-1');
          target.focus({preventScroll:true});
        }
        if (window.matchMedia('(max-width: 700px)').matches) root.scrollIntoView({behavior:'smooth',block:'start'});
      }
      function syncProduct() {
        var selected = form.querySelector('input[name="contact[Product]"]:checked');
        var choice = selected && selected.closest('[data-feedback-flavour-value]');
        var flavourValue = choice ? choice.getAttribute('data-feedback-flavour-value') : '';
        if (flavour) flavour.value = flavourValue;
        if (flavourLabel) {
          flavourLabel.textContent = flavourValue ? 'Flavour: ' + flavourValue : 'Choose a PlantBie product above';
        }
      }
      function syncRating() {
        var selected = form.querySelector('input[name="contact[Overall rating]"]:checked');
        var rating = selected ? Number(selected.value) : 0;
        stars.forEach(function (star) {
          var input = star.querySelector('input');
          star.classList.toggle('is-on', !!input && Number(input.value) <= rating);
        });
        if (ratingText) ratingText.textContent = rating ? rating + ' out of 5 stars' : 'Select a rating';
      }
      root.classList.add('pb-feedback--js');
      next.addEventListener('click', function () {
        for (var i = 0; i < [email, phone].length; i++) {
          var input = [email, phone][i];
          if (input && !input.reportValidity()) {
            input.focus();
            return;
          }
        }
        moveTo(true);
      });
      back.addEventListener('click', function () { moveTo(false); });
      radios.forEach(function (radio) { radio.addEventListener('change', syncProduct); });
      stars.forEach(function (star) {
        var input = star.querySelector('input');
        if (input) input.addEventListener('change', syncRating);
      });
      var params = new URLSearchParams(window.location.search);
      var requested = (params.get('product') || '').toLowerCase();
      if (requested) {
        var alias = {'eye':'eye-care','eyecare':'eye-care','cal':'calcium','calcium':'calcium','combo':'combo','eye-care':'eye-care'};
        var canonical = alias[requested] || requested;
        radios.forEach(function (radio) { if (radio.value === canonical) radio.checked = true; });
      }
      syncProduct();
      syncRating();
      form.addEventListener('submit', syncProduct);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();